import type { GridOptions, GridReadyEvent } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import type React from 'react';
import { useRef } from 'react';
import type { ProjectLogEntry } from '../../services/timeEntryService';
import {
  agGridContainerStyles,
  agGridDefaultColDef,
  agGridDefaultOptions,
  agGridTheme,
  agGridThemeStyles,
} from '../../theme/agGridTheme';

interface GridWrapperProps {
  entries: ProjectLogEntry[];
  columnDefs: any[];
  onGridReady: (event: GridReadyEvent) => void;
  onFirstDataRendered: () => void;
  onRowDataUpdated: () => void;
  onCellValueChanged: (event: any) => void;
  isLoading: boolean;
}

export const GridWrapper: React.FC<GridWrapperProps> = ({
  entries,
  columnDefs,
  onGridReady,
  onFirstDataRendered,
  onRowDataUpdated,
  onCellValueChanged,
  isLoading,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const popupParentRef = useRef<HTMLDivElement>(null);

  const gridOptions: GridOptions = {
    ...agGridDefaultOptions,
    theme: agGridTheme,
    suppressContextMenu: true,
    onGridReady,
    onFirstDataRendered,
    onRowDataUpdated,
    onCellValueChanged,
  };

  // Remove the default row logic - this should be handled by the parent component
  // useEffect(() => {
  //   if (entries.length === 0) {
  //     // This logic is now handled by ProjectLoggedHours component
  //   }
  // }, [entries.length]);

  return (
    <>
      <style>{agGridThemeStyles}</style>
      <div ref={popupParentRef} title="Project Logged Hours">
        <div className="ag-theme-quartz" style={agGridContainerStyles}>
          <AgGridReact
            ref={gridRef}
            rowData={entries}
            columnDefs={columnDefs}
            defaultColDef={agGridDefaultColDef}
            gridOptions={gridOptions}
            popupParent={popupParentRef.current}
            animateRows={true}
            enableCellTextSelection={true}
            ensureDomOrder={true}
            loading={isLoading}
          />
        </div>
      </div>
    </>
  );
};
